import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconCart.module.css';

const IconCart = props => {
    const { className, rootClassName } = props;
    const classes = classNames(rootClassName || css.root, className);

    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={classes}>
            <path d="M3.86231 0.648438L0.878418 0.663992L0.886967 2.4336L2.69849 2.42496L5.58154 9.41871L4.53393 11.114C4.18393 11.6803 4.16583 12.3956 4.48608 12.9787C4.80633 13.5618 5.41397 13.924 6.07372 13.924H16.625V12.1544H6.07372L6.01733 12.0507L7.04614 10.3847H13.5813C14.2174 10.3847 14.8028 10.035 15.1108 9.47402L18.2639 3.73662C18.4153 3.46233 18.4112 3.12775 18.2537 2.857C18.0962 2.58713 17.808 2.42151 17.4983 2.42151H4.59375L3.86231 0.648438ZM5.32178 4.19111H16.0115L13.5813 8.61514H7.14527L5.32178 4.19111ZM6.12501 14.8088C5.15851 14.8088 4.37501 15.601 4.37501 16.5784C4.37501 17.5557 5.15851 18.348 6.12501 18.348C7.09151 18.348 7.87501 17.5557 7.87501 16.5784C7.87501 15.601 7.09151 14.8088 6.12501 14.8088ZM14.875 14.8088C13.9085 14.8088 13.125 15.601 13.125 16.5784C13.125 17.5557 13.9085 18.348 14.875 18.348C15.8415 18.348 16.625 17.5557 16.625 16.5784C16.625 15.601 15.8415 14.8088 14.875 14.8088Z" />
        </svg>
    );
};

const { string } = PropTypes;

IconCart.defaultProps = {
    className: null,
    rootClassName: null,
};

IconCart.propTypes = {
    className: string,
    rootClassName: string,
};

export default IconCart;
